import * as Api from "../../api";

const state = {
  shouldAdvertiseAllUConnect: false,
}

const getters = {
  shouldAdvertiseAllUConnect: (state) => state.shouldAdvertiseAllUConnect,
}

const mutations = {
  SET_ADVERTISE_ALL_U_CONNECT(state, value) {
    state.shouldAdvertiseAllUConnect = value;
  },
}

const actions = {

  getPropertyRoomList({ state, rootState}, {params, callback}) {
    let obj = {
      action: `/oa/house/houseRoomList/${params.propertyId}`
    }
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "propertyRoomListCallback");
      }
    })
  },
  updateAdvertiseAllUConnect({ commit }, value) {
    commit('SET_ADVERTISE_ALL_U_CONNECT', value);
  },

  // getPropertyDetails({ state, rootState}, {params, callback}) {
  //   console.log('getPropertyDetails: ', params);
  //   let obj = {
  //     action: `/oa/house/house/connect/${params.propertyId}/${params.roomId}/ordersId`
  //   }
  //   if (params.ordersId) {
  //     obj = {
  //       action: `/oa/house/house/connect/${params.propertyId}/${params.roomId}/${params.ordersId}`
  //     }
  //   }
  //   Api.requestget(obj, { show: false }).then(resp => {
  //     if (callback) {
  //       callback(resp, "propertyDetailsCallback");
  //     }
  //   })
  // },

  getPropertyDetails({ state, rootState}, {params, callback}) {
    let obj = {
      action: `/oa/house/reserve/${params.propertyId}/${params.roomId}`
    }
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "propertyDetailsCallback");
      }
    })
  },

  submitReservationInfo({ state, rootState}, {params, callback}) {
    let obj = {
      action: `/oa/orders/reservation`,
      ...params
    }
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "submitCallback");
      }
    });
  },

  makeReservation({ state, rootState}, {params, callback}) {
    let obj = {
      action: `/oa/orders/create-checkout-session`,
      ...params
    }
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "makeReservationCallback");
      }
    });
  },

  createPropertyCommission({ state, rootState}, {payload, callback}) {
    let obj = {
      action: `/oa/house/create/propertyCommission`,
      ...payload
    }
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "callbackCreatePropertyDetails");
      }
    });
  },

  updatePropertyCommission({ state, rootState}, {payload, callback}) {
    let obj = {
      action: `/oa/house/update/propertyCommission`,
      ...payload
    }
    Api.requestput(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "callbackUpdatePropertyDetails");
      }
    });
  },
  getAgentListedProperties({ state, rootState}, {payload, callback}) {
    console.log(payload);
    let obj = {
      action: `/oa/house/house/agent/property/${payload.agentId}`
    }
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, payload.agentId, "callbackGetAgentListedProperties");
      }
    })
  },
  getPropertyCommission({ state, rootState}, {payload, callback}) {
    let obj = {
      action: `/oa/house/get/propertyCommission/values/${payload.propertyId}`
    }
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "callbackGetPropertyCommission");
      }
    })
  },

  createLookingForPropertyRequest({ state, rootState}, {payload, callback}) {
    let obj = {
      action: `/oa/house/create/lookingForPropertyRequest`,
      ...payload
    }
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "lookingForPropertyRequestCallback");
      }
    });
  },

  createReferClientRequest({ state, rootState}, {payload, callback}) {
    let obj = {
      action: `/oa/house/create/referClient`,
      ...payload
    }
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "referClientRequestCallback");
      }
    });
  },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/property.js